/**
 * Compact "24 min ago" formatter — lightweight, no Intl.RelativeTimeFormat
 * fallback handling needed because we render ASCII-only strings here.
 * Returns null when the input is null/missing.
 */
export function formatRelative(iso: string | null | undefined, now = Date.now()): string | null {
  if (!iso) return null;
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return null;
  const diff = Math.max(0, Math.floor((now - t) / 1000));
  if (diff < 45) return 'just now';
  if (diff < 90) return '1 min ago';
  const min = Math.floor(diff / 60);
  if (min < 60) return `${min} min ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr} hr ago`;
  const day = Math.floor(hr / 24);
  if (day < 30) return `${day} day${day === 1 ? '' : 's'} ago`;
  const mo = Math.floor(day / 30);
  if (mo < 12) return `${mo} mo ago`;
  const yr = Math.floor(mo / 12);
  return `${yr} yr ago`;
}
